import React from 'react';
import { Outlet, useLocation } from '@tanstack/react-router';
import { StepIndicator } from 'shared-portal-components-v2';

const TOTAL_STEPS = 5;

const STEP_MAP: Record<string, number> = {
  '/registration': 1,
  '/registration/verify-email': 2,
  '/registration/verify-phone': 3,
  '/registration/set-password': 4,
  '/registration/success': 5,
};

const RegistrationLayout: React.FC = () => {
  const location = useLocation();
  const currentStep = STEP_MAP[location.pathname] ?? 1;

  return (
    <div className="w-full flex justify-center">
      <div className="w-full max-w-md flex flex-col gap-8">
        <StepIndicator currentStep={currentStep} totalSteps={TOTAL_STEPS} />
        <Outlet />
      </div>
    </div>
  );
};

export default RegistrationLayout;
